import { TagColor } from '@equip.health/ui';

export const TreatmentLevelIdToTagColorMap: Record<number, TagColor> = {
  1: TagColor.green,
  2: TagColor.teal,
  3: TagColor.periwinkle,
  4: TagColor.marigold,
  5: TagColor.orange,
  6: TagColor.red,
  7: TagColor.purple,
};
